export const AGENCY_CONFIG = {
  name: 'Варна Имотен Център',
  phone: '+359 878 859 385',
  secondaryPhone: '+359 877 004 318',
  email: 'imotencentervarna1@gmail.com',
  address: 'гр. Варна, бул. Генерал Колев, 113, ет.3, офис 3.5',
  workingHours: {
    weekdays: 'Понеделник - Петък: 9:00 - 18:00',
    saturday: 'Събота: 10:00 - 14:00 (с дежурен брокер)',
    sunday: 'Неделя: Почивен ден'
  },
  social: {
    facebook: 'https://facebook.com',
    instagram: 'https://instagram.com',
    linkedin: 'https://linkedin.com'
  }
};
